import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ToastProvider } from './components/ToastContainer'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import Admin from './pages/Admin'
import AdminLogin from './pages/AdminLogin'
import Elise from './pages/Elise'
import EliseDashboard from './pages/EliseDashboard'
import EliseIdeas from './pages/EliseIdeas'
import ElisePlanDetail from './pages/ElisePlanDetail'
import EliseInventory from './pages/EliseInventory'
import './styles/App.css'

function App() {
  return (
    <ToastProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/elise" element={<Elise />} />
              <Route path="/elise/dashboard" element={<EliseDashboard />} />
              <Route path="/elise/ideas" element={<EliseIdeas />} />
              <Route path="/elise/plans/:id" element={<ElisePlanDetail />} />
              <Route path="/elise/inventory" element={<EliseInventory />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ToastProvider>
  )
}

export default App
